import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigation } from "hooks/useNavigation";
import BreadCrumb from ".";
import { ROUTES } from "utils/navigationUtils";

const HomeCrumb: FC = () => {
  const { navigateTo } = useNavigation();
  const { t } = useTranslation();

  return (
    <div style={{ margin: "2rem" }}>
      <BreadCrumb
        click={() => navigateTo(ROUTES.HOME)}
        crumbIcon={<HomeIcon fontSize="small" />}
        crumbText={`${t("crumbText.home")}`}
      />
    </div>
  );
};

export default HomeCrumb;
